import { CanActivateFn } from '@angular/router';
import { OnboardingStepsService } from './onboarding-steps.service';
import { inject } from '@angular/core';

export const onboardingSurveyGuard: CanActivateFn = (route, state) => {
  const onboardingStepsService = inject(OnboardingStepsService);

  if (onboardingStepsService.currentStep()?.key === 'survey'
  || onboardingStepsService.currentStep()?.fallback?.key === 'survey') {
    return true;
  }

  onboardingStepsService.navigateToCurrent();
  return false;
};
